import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=a927a9bc&scoped=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&lang=js"
import style0 from "./ArrowIcon.vue?vue&type=style&index=0&id=a927a9bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a927a9bc",
  null
  
)

export default component.exports